module.exports = __webpack_public_path__ + "static/js/fileWorker.db816111.chunk.worker.js"